module.exports = __webpack_public_path__ + "fonts/dripicons-v2.cf09c981.ttf";